<template>
  <v-card>
    <v-card-title>
      <p class="pl-6" v-html="$t('common.pef_list_assigned_detail')"></p>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      @click:row="handleClick"
      :headers="headers"
      :items="users"
      :loading="loading"
      item-key="id"
      class="elevation-1 row-pointer"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="-1"
      :items-per-page="-1"
      dense
    >
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.squad="{ item }">
        <span v-if="item.squad">
          {{ item.squad.name }}
        </span>
        <span v-else>N/A</span>
      </template>
      <template #item.period="{ item }">
        {{ formatDate(item.start_period) }} -
        {{ formatDate(item.end_period) }}
      </template>
      <template #item.action="{}">
        <v-icon small color=" darken-2"> mdi-arrow-right </v-icon></template
      >
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import Vue from "vue"
import { DEFAULT_DATE, FORMAT_DATE } from "@/utils/config"

const { mapActions } = createNamespacedHelpers("user_pcr")

export default {
  name: "PefPcrInativeTable",
  components: {},
  mixins: [TableMixin],
  data() {
    return {
      items: [],
      params: { is_active: false },
    }
  },

  computed: {
    users() {
      return this.$store.state.user_pcr.data
    },

    headers() {
      return [
        {
          value: "pef.first_name",
          text: this.$tc("user.first_name", 1),
          width: "15%",
        },
        {
          value: "pef.last_name",
          text: this.$tc("user.last_name", 1),
          width: "15%",
        },
        {
          value: "pef.squad.name",
          text: this.$tc("user.squad", 1),
          width: "24%",
        },
        {
          value: "pef.year",
          text: this.$tc("user.year", 1),
          width: "10%",
        },
        {
          value: "period",
          text: this.$tc("common.period", 1),
          width: "30%",
        },

        {
          value: "action",
        },
      ]
    },
  },

  methods: {
    ...mapActions([FETCH]),
    formatDate(date) {
      return Vue.moment(date, DEFAULT_DATE).format(FORMAT_DATE)
    },
    handleClick(pcr) {
      this.$router.push({ name: "users", params: { user_id: pcr.pef.id } })
    },
  },
}
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
